import Vue from 'vue';
import Router from 'vue-router';
import { store } from '../store';

import Login from './login';
import Version from './version';
import Welcome from './welcome';
import Dashboard from './dashboard';
import DashboardParking from './dashboard-parking';
import ReportNotify from './report-notify';
import ReportCredit from './report-credit';
import ReportEmployeeSales from './report-employee-sales';
import ReportEmployeeEmissions from './report-employee-emissions';
import ReportBilling from './report-billing';
import OutdatedRegister from './outdated-register';
import BulkOutdatedRegister from './bulk-outdated-register';
import Roles from './roles';
import RegisterEmployee from './register-employee';
import VehicleHistory from './vehicle-history';
import Reversal from './reversal';
import ReportSyntheticCredit from './report-synthetic-credit';
import ReportOpenedDebits from './report-opened-debits';
import ReportParkedNotified from './report-parked-notified';
import ReportOccupationRate from './report-occupation-rate';
import MonitorMessage from './monitor-message';
import ConsumerMessage from './consumer-message';
import CreateCampaign from './create-campaign';
import ParkingMap from './parking-map';
import UsageDensity from './usage-density';
import EmployeeMap from './employee-map';
import WalletBonus from './wallet-bonus';
import WalletReversal from './wallet-reversal';
import AssignUserClient from './assign-user-client';
import CreateZone from './create-zone';
import TariffPlan from './tariff-plan';
import RelateTariffSchedule from './relate-tariff-schedule';
import TariffSchedule from './tariff-schedule';
import RegisterPark from './register-park';
import Reports from './reports';
import CloseAccountingCash from './close-accounting-cash';
import CashRelief from './cash-relief';
import CashWithdraw from './cash-withdraw';
import CashReinforcement from './cash-reinforcement';
import Labels from './labels';
import ManagerAccountingCash from './manager-accounting-cash';
import AccountingCashReport from './accounting-cash-report';
import CloseAccountingInfo from './closed-accounting-info';
import ChangeClient from './change-client';
import ConsumerList from './consumer-list';
import ConsumerInfo from './consumer-info';
import Clients from './clients';
import FinancialAccount from './financial-account';
import AccountMovement from './account-movement';
import MovementInfo from './movement-info';
import GuardRequest from './guard-request';
import ManagerGuardRequest from './manager-guard-request';
import RelateScheduleSpots from './relate-schedule-spots';
import Creditor from './creditor';
import RolesManagement from './roles-management';
import FinancialAccountHistory from './financial-account-history';
import FinancialAccountHistoryTable from './financial-account-history-table';
import SettledCredits from './settled-credits';
import RegisterPriceTicket from './register-price-ticket';
import RegisterPointOfInterest from './register-point-of-interest';
import Vehicle from './vehicle';
import ParkingMeter from './parking-meter';
import AllowPayment from './allow-payment';
import ReactivePayment from './reactive-payment';
import GuardNotifications from './guard-notifications';
import GuardConfig from './guard-config';
import Serpro from './serpro';

import ReportEmployeeEmissionsList from './report-employee-emissions-list';
import ReportEmployeeSalesList from './report-employee-sales-list';

import CameraMonitor from './camera-monitor';
import CameraAgente from './camera-agente';
import SentinelOriana from './sentinel-oriana';

import AberturaParquimetro from './abertura-parquimetro';
import AtmMap from './atm-map';
import PrintConfig from './print-config';

import OcrReport from './ocr-report';

import Analytics from './analytics';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    AberturaParquimetro,
    AtmMap,
    Login,
    Version,
    Welcome,
    Dashboard,
    DashboardParking,
    ReportNotify,
    ReportCredit,
    ReportBilling,
    OutdatedRegister,
    BulkOutdatedRegister,
    Roles,
    RegisterEmployee,
    ...VehicleHistory,
    Reversal,
    ReportSyntheticCredit,
    ReportOpenedDebits,
    ReportParkedNotified,
    ReportOccupationRate,
    ...ReportEmployeeSales,
    ...ReportEmployeeEmissions,
    ...MonitorMessage,
    ...ConsumerMessage,
    CreateCampaign,
    ParkingMap,
    UsageDensity,
    EmployeeMap,
    WalletBonus,
    WalletReversal,
    AssignUserClient,
    CreateZone,
    TariffPlan,
    RelateTariffSchedule,
    TariffSchedule,
    RegisterPark,
    ...Reports,
    CloseAccountingCash,
    CashRelief,
    CashWithdraw,
    CashReinforcement,
    Labels,
    ManagerAccountingCash,
    AccountingCashReport,
    CloseAccountingInfo,
    ChangeClient,
    ConsumerList,
    ConsumerInfo,
    Clients,
    FinancialAccount,
    AccountMovement,
    ...MovementInfo,
    GuardRequest,
    ...ManagerGuardRequest,
    RelateScheduleSpots,
    Creditor,
    RolesManagement,
    FinancialAccountHistory,
    FinancialAccountHistoryTable,
    SettledCredits,
    RegisterPriceTicket,
    RegisterPointOfInterest,
    Vehicle,
    ParkingMeter,
    CameraMonitor,
    CameraAgente,
    SentinelOriana,
    OcrReport,
    AllowPayment,
    PrintConfig,
    ...GuardNotifications,
    GuardConfig,
    ReportEmployeeEmissionsList,
    ReportEmployeeSalesList,
    ReactivePayment,
    ...Analytics,
    ...Serpro
  ],
});

router.beforeEach((to, from, next) => {
  const userToken = store.getters['DATA-ACCESS/getUserToken']
  if (to && to.meta && to.meta.role && to.meta.role.sectorId === 'public') {
    return next();
  }
  if (!userToken && to.path !== '/') {
    return next({ path: '/' });
  }

  if (!to.meta.role) {
    return { path: '/' };
  }
  const { sectorId } = to.meta.role;
  if (sectorId === 'login' || sectorId === 'dashboard-parking' || sectorId === 'welcome') {
    return next();
  }
  const HasAccess = store.getters['DATA-ACCESS/HasAccess'](sectorId, 'SHOW');
  if (HasAccess) {
    return next();
  }

  next({ path: '/' });
});

export default router;
